import $ from 'jquery';
import { blockUi, unblockUi } from './blockui';
import { addNotification } from './notifications';

const $wrapper = $('.woocommerce');
const updateCart = () => {
    //$('[name="update_cart"]').removeAttr('disabled').click();
    $.ajax({
        url: tromplo.ajax_url,
        type: 'post',
        data: {
            action: 'wc_cart_updated',
        }
    })
        .done(response => {
            if (response['status'] === 'success') {
                if (response['html'].length) {
                    unblockUi($wrapper);
                    $(".article-body .woocommerce").html(response['html']);
                }
                
            }
            else if(response['status'] === "cart_empty"){
                location.reload();
            } else {
                addNotification(response['message'], 'error');
            }
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
};

$("body").on("click", ".item__actions-remove", function(e){
    e.preventDefault();
    blockUi($wrapper);
    $.ajax({
        url: tromplo.ajax_url,
        type: 'post',
        data: {
            remove_id: $(this).attr('data-remove'),
            action: 'wc_remove_from_cart',
        }
    })
        .done(response => {
            if (response['status'] === 'success') {
                updateCart();
            }
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
 
})

$("body").on("click",'.coupon_code_submit',function(e){
    e.preventDefault();
    let coupon_text = $("#coupon_code").val();
    if(!coupon_text){return};
    blockUi($wrapper);
    $.ajax({
        url: tromplo.ajax_url,
        type: 'post',
        data:{
            coupon_code: coupon_text,
            action:"wc_check_coupon",
        }
    })
    .done((response)=>{
        if (response['status'] === 'success') {
            addNotification("Coupon code applied successfully");
            updateCart();
         }else if(response['status'] === 'has_coupon'){
            addNotification(response['error'],'error');
            updateCart();
         }else{
            addNotification(response['error']['errors']['invalid_coupon'],'error');
            updateCart();
         }
    })
    .fail(response => {
        addNotification('Error. Try again later.', 'error');
    })
});



    $("body").on('click','.product-type-change a',function () {
        const $this = $(this);
        if($wrapper){
            blockUi($wrapper);
        }
        $.get($this.data('remove'), (data) => {
            $.get($this.data('add'), (data) => {
                updateCart();
            });
        })
    });

// TODO: jak będzie działać togglowanie to wywalić w następnym patchu
// export const bindTypeChange = () => {
//     bindToggle();

//     const observer = new MutationObserver((mutations) => {
//         bindToggle();
//         unblockUi($wrapper);
//     });

//     observer.observe($wrapper[0], {
//         attributes: false,
//         childList: true,
//         characterData: true
//     });
// };

const bindButtons = () => {
    $('.product-freebie').on('click', function () {
        const $this = $(this);
        $this.next('.confirm').remove();

        const $confirm = $(`
            <div class="confirm">
                <span>Are you sure you want to get a coupon?</span>
                <a href="#" class="yes">Yes</a>
                <a href="#" class="no">No</a>
            </div>
        `);
        $confirm.insertAfter($this);

        $confirm.find('.no').on('click', () => {
            $confirm.remove();
        });

        $confirm.find('.yes').on('click', () => {
            $confirm.remove();
            blockUi($wrapper);
            $.ajax({
                url: tromplo.ajax_url,
                method: 'POST',
                data: {
                    action: 'get_freebie_coupon',
                    product: +$this.data('id'),
                },
            })
                .done(response => {
                    addNotification(response['message'], response['status']);
                    $('.user-points b').text(response['new_points']);
                })
                .fail(response => {
                    addNotification('Error. Try again later.', 'error')
                })
                .always(response => {
                    updateCart();
                });
        });
    });
};

export const bindPointsPurchase = () => {
    bindButtons();

    const observer = new MutationObserver((mutations) => {
        bindButtons();
        unblockUi($('.woocommerce'));
    });

    observer.observe($('.woocommerce')[0], {
        attributes: false,
        childList: true,
        characterData: true
    });
};
